import { createSelector } from 'reselect'
import { getPageParams, getPageData } from 'selectors/page'
import { searchIndice, sortOptions } from '../helpers/constants'
import { SAArtwork } from 'types/Artwork'

export const getAlgoliaResults = createSelector(
  getPageData,
  (pageData): Record<string, any> => pageData.algoliaResults || {}
)

export const getHits = createSelector(
  getAlgoliaResults,
  (algoliaResults): Record<string, any> => algoliaResults.hits || {}
)

export const getHitsResults = createSelector(
  getHits,
  (hits): ReadonlyArray<SAArtwork> => hits.results || []
)

export const getSort = createSelector(
  getPageParams,
  (pageParams): string => pageParams.sort || 'default'
)

export const getSortIndice = createSelector([getSort], (sort): string => {
  const currentOption = sortOptions.find((option) => option.value === sort)
  return currentOption ? currentOption.indice : searchIndice
})

export const getHitsPerPage = createSelector(getHits, (hits): number => hits.perPage || 100)

export const getHitsTotal = createSelector(getHits, (hits): number => hits.total || 0)

export const getPagination = createSelector(
  getAlgoliaResults,
  (algoliaResults): Record<string, any> => algoliaResults.pagination || {}
)

export const getPaginationCurrent = createSelector(
  [getPagination, getPageParams],
  (pagination, pageParams): number => pagination.current || Number(pageParams.page - 1) || 0
)

export const getFirstResultsArtwork = createSelector([getHitsResults], (results): string => {
  if (results && results[0]) {
    return results[0].imageUrl || ''
  }

  return ''
})

export const getHitsAvailableForSaleCount = createSelector([getHitsResults], (results): number =>
  results.reduce((count, { originalStatus }) => (count += originalStatus === 'avail' ? 1 : 0), 0)
)
